export default {
      id: "eye-usage",
      viewBox: "0 0 39 30",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#eye",
      toString: function () {
        return this.url;
      }
    }